"use client";

import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@/lib/storyblok-editable";

import { surfaceFrom } from "@/components/optilase/surface";
import { cn } from "@/lib/utils";

import { CtaButton } from "@/components/optilase/cta-button";

type LpCtaBlok = SbBlokData & {
  heading?: string;
  body?: string;
  cta_label?: string;
  note?: string;
  bg_color?: unknown;
};

export default function LpCta({ blok }: { blok: LpCtaBlok }) {
  const surface = surfaceFrom(blok.bg_color);
  return (
    <section
      {...storyblokEditable(blok)}
      style={surface ? { backgroundColor: surface.backgroundColor } : undefined}
      className={cn(
        "px-5 py-14 text-white md:px-10 lg:px-20 lg:py-20",
        surface ? "" : "bg-teal-08",
      )}
    >
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center gap-6 text-center">
        {blok.heading && <h2 className="text-section text-white">{blok.heading}</h2>}
        {blok.body && (
          <p className="max-w-160 text-base leading-relaxed text-white/80 lg:text-xl">
            {blok.body}
          </p>
        )}
        <CtaButton
          action="open_booking"
          variant="orange"
          keepOnMobile
          className="h-16 w-full px-10 text-lg sm:w-fit"
        >
          {blok.cta_label || "Book consultation"}
        </CtaButton>
        {blok.note && <p className="text-sm text-white/60">{blok.note}</p>}
      </div>
    </section>
  );
}
